import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  circle,
  fileAcceptAnimation,
  fileRejectAnimation,
  flexCenter,
  flexColumn,
  flexSpBetween,
  rem,
} from "@styles/Utilities.styled";


export const StyledAddDoctorModalContent = styled.div`
  ${flexColumn}

  padding-bottom: 1.5rem;

  .step-title {
    color: var(--clr-primary-400);
    font-size: ${rem(15)};
    font-weight: 500;
    margin-bottom: 1.5rem;
  }

  .form {
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;

    .form-field {
      margin-bottom: 1.5rem;
    }

    .form-actions {
      display: flex;
      justify-content: flex-end;
      padding-top: 1.5rem;
      margin-top: 1rem;
    }
  }

  .form-field {
    margin-bottom: 1.5rem;
  }

  .form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .photo-upload-button {
    position: absolute;
    bottom: -5px;
    right: -5px;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    background-color: var(--mantine-color-primary-6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: var(--mantine-color-primary-7);
    }
  }

  .files-wrapper {
    margin-top: 0.5rem;
    font-size: ${rem(14)};

    .dropzone {
      ${flexCenter}
      height: ${rem(200)};
      padding: 2rem;
      background-color: var(--clr-gray-100);
      border: 2px dashed var(--clr-primary-700);
      border-radius: var(--border-radius-2);
      cursor: pointer;
      transition: all 0.2s ease;
      margin-bottom: 1rem;

      &.active {
        border: 2px dashed var(--clr-primary-400);
        background-color: ${alpha("var(--clr-primary-400)", 0.05)};
      }

      &.accept {
        background-color: var(--green-3);
        border-color: var(--green-8);
        animation: ${fileAcceptAnimation} 1s var(--ease-slow-start) forwards;
      }

      &.reject {
        background-color: ${alpha("var(--clr-rose)", 0.15)};
        border-color: ${alpha("var(--clr-rose)", 0.8)};
        animation: ${fileRejectAnimation} 0.1s ease-out 4 forwards;
      }

      .text-content {
        ${flexColumn}
        align-items: center;
        gap: 1.5rem;
        text-align: center;

        .p-wrapper {
          ${flexColumn}
          gap: 0.5rem;

          p:first-child {
            font-weight: 500;
            font-size: ${rem(16)};
            color: var(--clr-primary-700);
          }

          p:last-child {
            font-size: ${rem(14)};
            color: var(--clr-gray-400);
          }
        }

        .svg-wrapper {
          ${flexCenter}
          ${circle(rem(70))}
          background-color: ${alpha("var(--clr-primary-400)", 0.1)};
        }
      }


    }

    .uploaded-files {
      margin-top: 1.5rem;

      h4 {
        font-weight: 500;
        font-size: ${rem(15)};
        margin-bottom: 1rem;
        color: var(--clr-primary-700);
      }

      ul {
        ${flexColumn}
        gap: 0.75rem;

        li {
          ${flexSpBetween}
          align-items: center;
          gap: 1rem;
          padding: 0.75rem 1rem;
          border: 1px solid var(--clr-gray-175);
          border-radius: var(--border-radius-2);
          background-color: var(--clr-white);

          .content {
            ${alignItemsCenter}
            gap: 0.5rem;
            flex: 1;

            span {
              font-size: ${rem(14)};
              color: var(--clr-primary-700);
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .browse-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: 1px solid var(--clr-primary-400);
    border-radius: var(--border-radius-2);
    background-color: transparent;
    color: var(--clr-primary-400);
    font-size: ${rem(14)};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${alpha("var(--clr-primary-400)", 0.05)};
    }
  }

  .file-preview {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border: 1px solid var(--clr-gray-175);
    border-radius: var(--border-radius-2);
    background-color: var(--clr-white);
    margin-top: 0.5rem;

    .file-name {
      flex: 1;
      font-size: ${rem(14)};
      color: var(--clr-primary-700);
      font-weight: 500;
    }

    .remove-button {
      color: var(--clr-rose);
      cursor: pointer;
      font-size: ${rem(18)};
      font-weight: bold;

      &:hover {
        color: ${alpha("var(--clr-rose)", 0.8)};
      }
    }
  }

  /* Form field styling overrides */
  .mantine-Select-root {
    .mantine-Select-label {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }

  .mantine-TextInput-root {
    .mantine-TextInput-label {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }

  .mantine-Textarea-root {
    .mantine-Textarea-label {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }

  .mantine-TagsInput-root {
    .mantine-TagsInput-label {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
  }

  .mantine-Checkbox-root {
    .mantine-Checkbox-label {
      font-weight: 500;
    }
  }

  .mantine-Radio-root {
    .mantine-Radio-label {
      font-weight: 500;
      font-size: 0.8rem;
    }

    // Override global input styling that interferes with radio buttons
    .mantine-Radio-radio {
      padding: 0;
    }
  }

  .file-upload-container {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 24px;
    text-align: left;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.2s ease;

    .upload-text {
      color: var(--clr-primary-400);
      font-weight: 500;
      margin-bottom: 8px;
    }

    .upload-info {
      color: var(--clr-gray-400);
      margin-bottom: 24px;
    }

    .upload-button {
      border-color: #e9ecef;
      color: black;

      .upload-icon {
        color: var(--clr-primary-400);
      }
    }
  }

  .file-preview-container {
    margin-top: 8px;
    padding: 12px;
    background-color: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--clr-primary-400);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .file-info {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      .file-icon {
        color: var(--clr-primary-400);
        flex-shrink: 0;
      }

      .file-details {
        flex: 1;
        min-width: 0;

        .file-name {
          font-size: ${rem(14)};
          font-weight: 500;
          color: var(--clr-primary-700);
          margin-bottom: 2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .file-size {
          font-size: ${rem(12)};
          color: var(--clr-gray-400);
        }
      }
    }

    .remove-button {
      flex-shrink: 0;
    }
  }


`;
